module.exports = __webpack_public_path__ + "img/logo_background.893893b3.svg";